<template>
  <div class="testing-page">
      <div>
          <input type="text" class="input-box large-input-box" placeholder="Enter Session Id" v-model="sessionId">
          <input type="text" class="input-box" placeholder="Enter Start Time" v-model="startTime">
          <input type="text" class="input-box" placeholder="Enter End Time" v-model="endTime">
          <input type="number" class="input-box"  placeholder="Time Delay" v-model="timeDelay">
          <b-button type="submit" @click="getSessionIdData()">Start Rendering</b-button>
      </div>
      <div>
          <div class="float-container">
              <div class="float-child">
                  <p class="header-label">Trainer :  Trainer Time: {{ trainerVideoTime }} <!--  : Length of Trainer Data: {{  lengthOfTrainerData }} -->
                  </p>
                  <p class="loader" v-if="trainerDataLoaded">Loading.....</p>
                  <hr></hr>
                  <canvas id="trainerCanvas" height="500" width="600"></canvas>
              </div>
              <div class="float-child">
                  <p class="header-label">User : User Time: {{ userVideoTime }} <!-- : Length of User Data: {{ lengthOfUserData }}</p> -->
                  <p class="loader" v-if="userDataLoaded">Loading.....</p>
                  <hr></hr>
                  <canvas id="userCanvas" height="500" width="600"></canvas>
              </div>
          </div>
          <div>
              <div class="time-label">
                <span id="startTime">Start Time: {{ startTime }} sec</span>
                <span id="currentTime">Current Time: {{ sliderValue }} sec</span>
                <span id="endTime">End Time: {{ endTime }} sec</span>
              </div>
              <input type="range" name="slider" :title="sliderValue" :min="startTime" :max="endTime" v-model="sliderValue" @input="updateKeyPoints()" :disabled="disableSlider" class="slider" style="background-color: green;" />
          </div>
          <div class="angleTable">
            <div>
              <label>Total Repetition Count</label>
              <p>{{ repCountMessage }}</p>
            </div>
            <table v-if="showTable" style="width:100%">
              <tr>
                <th>Sticker</th>
                <th>Average Accuracy Score</th>
                <th>Instant Score</th>
                <!-- <th v-if="repData.rep_count">Rep Count</th>
                <th v-else>Message</th> -->
              </tr>
              <tr v-if="updatedStickersAndScores.length > 0">
                <th>{{ updatedStickersAndScores[0].message }}</th>
                <th>{{ updatedStickersAndScores[0].instance_score }}</th>
                <th>{{ updatedStickersAndScores[0].accuracy_score }}</th>
                <!-- <th v-if="repData.rep_count">{{ repData.rep_count }}</th>
                <th v-else> {{  repData.Message }}</th> -->
              </tr>
          </table>
        </div>
          <!-- <b-button type="button" class="btn btn-success btn-circle btn-sm">{{ userKeyPoints.time }}</b-button> -->
          <!-- <div class="btn-group mr-2" role="group" v-for="keyPointSpan in userKeyPoints">
            <b-button type="button" class="btn btn-secondary">{{ keyPointSpan.time }}</b-button>
          </div> -->
      </div>
      <div class="scoreGraph">
        <line-chart v-if="showGraph" :chart-data="chartData" :options="chartOptions"></line-chart>
      </div>
      <div class="repGraph">
        <line-chart v-if="showGraph" :chart-data="repchartData" :options="chartOptions"></line-chart>
      </div>
  </div>
      
  </template>
  <script>
  import {drawConnectors, drawLandmarks} from "@mediapipe/drawing_utils/drawing_utils.js";
  import {Pose, POSE_CONNECTIONS} from "@mediapipe/pose/pose.js";
  import api from '../api.js';
  import LineChart from "@/module_user/components/LineChart";
  export default {
      data: function() {
          return {
              repData: {
                rep_count: false,
                Message: ''
              },
              userVideoTime: null,
              trainerVideoTime: null,
              lengthOfTrainerData: null,
              lengthOfUserData: null,
              sessionId: null,
              startTime: null,
              endTime: null,
              showGraph: false,
              canvas: '',
              canvasCtx: '',
              userKeyPoints: null,
              trainerKeyPoints: null,
              scoresData: null,
              timeDelay: null,
              sliderValue: 0,
              disableSlider: true,
              trainerDataLoaded: false,
              currentSticker:null,
              avgScore: null,
              instanceScore: null,
              repCountMessage: '',
              chartData: {
                labels: [],
                datasets: [
                  {
                    label: 'Average Accuracy Score',
                    backgroundColor: '#00ff00',
                    data: []
                  }
                ]
              },
              repchartData: {
                labels: [],
                datasets: [
                  {
                    label: 'Repetition Count',
                    backgroundColor: '#275384',
                    borderColor: "#ff0000",
                    borderWidth: 1,
                    data: []
                  }
                ]
              },
            chartOptions: {
            responsive: true,
            maintainAspectRatio: false
            },
            frame_stamps:[],
            trainerAngles: {},
            userAngles: {},
            showTable: false,
            userDataLoaded: false,
            trainerDataLoaded: false,
            estimatedStartRequestTime:0,
            estimatedEndRequestTime:0,
            updatedStickersAndScores: {}
          }
      },
      components: {
        LineChart
      },
      methods: {
          async getRepCount(keypointData, baselineFolder) {
            console.log("called get rep count function");
            let repRequestData = {
              "session_id": this.sessionId,
              "startTime": this.startTime,
              "endTime": this.endTime
            }
            let steps = []
            let time = []
            let poseBy = []
            for(let pose of keypointData) {
              steps.push(pose['steps']);
              time.push(pose['time']);
              poseBy.push('BP');
            }
            let rate=0, index = 0, finalCount=0
            let prevState = null, prevCount = 0
            while (index < time.length) {
              rate = 0;
              while(index + rate < time.length && time[index+rate]-time[index]<this.timeDelay)
              rate++;
              repRequestData["steps"] = steps.slice(index, index + rate);
              repRequestData["time"] = time.slice(index, index + rate);
              repRequestData['poses'] = poseBy.slice(index, index + rate);
              repRequestData['prevState'] = prevState;
              repRequestData['prevCount'] = prevCount;
              index += rate;
            let repCounterResponse = await api.repCounter(repRequestData, baselineFolder);
            console.log(repCounterResponse.data);
            try{
              this.repCountMessage = repCounterResponse.data.rep_count.Count;
              if(repCounterResponse.data.rep_count.Count>finalCount)
              {
              let frame_number = [];
              for(let ts of repCounterResponse.data.rep_count.Timestamp) {
                finalCount+=1;
                this.repCountMessage ='Time:' + repRequestData["time"][ts[1]] + "s Count:" + finalCount;
                this.frame_stamps.push(repRequestData["time"][ts[1]]);
              }
              prevCount = finalCount;
              }
              prevState = repCounterResponse.data.rep_count.state;
            }
            catch(error) {
              this.repCountMessage = repCounterResponse.data.Message;
              console.log(this.repCountMessage);
            }
            }
          },
          async getSessionIdData() {
              this.scoresData = null;
              this.userKeyPoints = null;
              this.trainerKeyPoints = null;
              this.userDataLoaded = true;
              this.trainerDataLoaded = true;
              const requestData= {
                "sessionId": this.sessionId,
                "startTime": this.startTime,
                "endTime": this.endTime
              }
              if (requestData.sessionId != null, requestData.startTime != null, requestData.endTime != null) {
                  this.sliderValue = this.startTime;
                  this.disableSlider = false;
                  try {
                    this.scoresData = await api.getScoreData(requestData.sessionId);
                    this.userKeyPoints = await api.getSessionData(requestData);
                    let baseline_folder =  this.userKeyPoints[0].baseline_folder;
                    await this.getRepCount(this.userKeyPoints, baseline_folder);
                    this.trainerKeyPoints = await api.getTrainerData(baseline_folder);
                    this.lengthOfTrainerData = this.trainerKeyPoints.length;
                    this.lengthOfUserData = this.userKeyPoints.length;
                    this.drawCanvas(this.trainerKeyPoints, "trainer");
                    this.drawCanvas(this.userKeyPoints, "user");
                    this.drawGraph();    
                    } catch(error) {
                    this.trainerDataLoaded = false;
                    this.userDataLoaded = false;
                    console.log(error);
                    this.$bvToast.toast('Unable to fetch data', {
                      title: 'Error',
                      variant: 'danger',
                    });
                  }  
              }
              else {
                this.trainerDataLoaded = false;
                this.userDataLoaded = false;
                this.$bvToast.toast('Enter Missing Values', {
                  title: 'Missing Values',
                  variant: 'danger',
                });
              }
          },
          async drawStickFigure(keypoints, canvas, canvasCtx) { 
            canvasCtx.clearRect(0, 0, 600, 500);     
            drawConnectors(canvasCtx, keypoints, POSE_CONNECTIONS);
            drawLandmarks(canvasCtx, keypoints);
          },
          async drawGraph() {
            for(let score of this.scoresData) {
              this.chartData.labels.push(`${score.start_time}-${score.end_time}`);
              this.chartData.datasets[0].data.push(score.accuracy_score);
            }
            for(let stamp of this.frame_stamps) {
              this.repchartData.labels.push(`${stamp}`);
              this.repchartData.datasets[0].data.push(this.frame_stamps.indexOf(stamp)+1);
            }
            this.showGraph = true;
          },
          async drawCanvas(keyPoints, kind) {
              if (kind === "trainer") {
                this.trainerDataLoaded = false;
                const trainerCanvas = document.getElementById("trainerCanvas");
                const trainerCanvasCtx = trainerCanvas.getContext("2d");
                if(this.startTime > 3) {
                  this.estimatedStartRequestTime = Math.abs(Math.ceil((this.startTime/3) - 2));
                  this.estimatedEndRequestTime = Math.abs(Math.ceil((this.endTime/3) + 2));
                }
                for(let iterator=this.estimatedStartRequestTime; iterator <= this.estimatedEndRequestTime; iterator++) {
                  let currentKeyPoints = this.trainerKeyPoints[iterator].poses;
                  for(let keyPoint of currentKeyPoints) {
                    if(keyPoint.time >= this.startTime && keyPoint.time <= this.endTime) {
                      this.trainerVideoTime = keyPoint.time;
                      this.drawStickFigure(keyPoint.steps.pose, trainerCanvas, trainerCanvasCtx);
                      await this.sleep(this.timeDelay);
                    }
                  }
                }
              }
              
              // User Pose
              if (kind === "user") {
                this.userDataLoaded = false;
                const userCanvas = document.getElementById("userCanvas");
                const userCanvasCtx = userCanvas.getContext("2d");
                for(let keyPoint of keyPoints) {
                    this.userVideoTime = keyPoint.time;
                    this.showTable = true;
                    this.drawStickFigure(keyPoint.steps.pose, userCanvas, userCanvasCtx);
                    await this.updateScoresTable(this.userVideoTime);
                    await this.sleep(this.timeDelay);
                    this.sliderValue = keyPoint.time;
                }
              }
          },
  
          async updateScoresTable(userVideoTime) {
            this.updatedStickersAndScores = this.scoresData.filter(function (scores) {
              return scores.start_time >= parseInt(userVideoTime) && scores.end_time <= parseInt(userVideoTime) + 10;
            })
          }, 
          
          async updateKeyPoints() {
            const currentTime = this.sliderValue;
            this.startTime = currentTime;
            this.endTime = parseInt(currentTime) + 1;
            const selectedTimeFrameData = this.userKeyPoints.filter(function (keyPoint) {
              return keyPoint.time >= currentTime && keyPoint.time <= currentTime + 3;
            })
            this.drawCanvas(selectedTimeFrameData, "user");
            this.drawCanvas(selectedTimeFrameData, "trainer");
          },
          async sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
          }
        }
      }
  </script>
  <style lang="scss" scoped>
  .float-container {
      padding: 10px;
  }
  
  .input-box {
    border-radius: 5px;
    padding:5px;
  }
  
  .large-input-box {
    width: 22%;
  }
  
  .float-child {
      width: 50%;
      float: left;
      padding: 10px;
      border: 3px solid white;
  }  
  hr {
      color:white;
  }
  
  .slider {
    width: 98%;
    padding: 10px;
    margin: 10px;
    color: green;
    // background-color: green;
  }
  
  .angle-red {
    background-color: red;
  }
  
  .angle-green {
    background-color: green;
  }
  
  .time-label {
    color: white;
    padding: 10px;
    font-size: 20px;
  }
  
  #startTime {
    width: 34%;
    float:left;
    text-align: left;
  }
  
  #currentTime {
    width: 33%;
    float: left;
    text-align: center;
  }
  
  #endTime {
    width: 33%;
    float: left;
    text-align: right;
  }
  
  .scoreGraph{
    background-color: black;
  }
  
  .testing-page{
    background-color: black;
  }
  
  .angleTable{
    background-color: white;
    color: black;
  }
  
  table, th, td {
    margin: auto;
    border:1px solid black;
  }
  
  .header-label{
    color: white;
  }
  </style>